<div
    *ngFor="let section of sectionData"
    class="d-flex align-items-center bg-gray-500 px-5 py-4 mb-4"
    style="border-radius: 5rem"
>
    <div style="width: 33%; text-align: left">
        <span class="text-gray-light montserrat-light text-uppercase mr-2"
            >{{ section.labelColumn1 }}:</span
        >
        <span class="text-white montserrat-medium">
            <span *ngIf="section.valueColumn1 != null">{{
                section.valueColumn1.value | currency: section.valueColumn1.suffix
            }}</span>
            <span *ngIf="section.valueColumn1 == null">0</span>
        </span>
    </div>
    <hr class="vertial-separator" />
    <div style="width: 33%; text-align: center">
        <span class="text-gray-light montserrat-light text-uppercase mr-2"
            >{{ section.labelColumn2 }}:</span
        >
        <span *ngIf="section.labelColumn2.suffix == '%'" class="text-white montserrat-medium">{{
            section.valueColumn2.value + section.valueColumn2.suffix
        }}</span>
        <span *ngIf="section.labelColumn2.suffix != '%'" class="text-white montserrat-medium">{{
            section.valueColumn2.value | currency: section.valueColumn2.suffix
        }}</span>
    </div>
    <hr class="vertial-separator" />
    <div style="width: 33%; text-align: right">
        <span class="text-gray-light montserrat-light text-uppercase mr-2"
            >{{ section.labelColumn3 }}:</span
        >
        <span class="text-white montserrat-medium">
            <span *ngIf="section.valueColumn3 != null">{{
                section.valueColumn3.value | currency: section.valueColumn3.currencyCode
            }}</span>
            <span *ngIf="section.valueColumn3 == null">0</span>
        </span>
    </div>
</div>
